import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { admin, cpanelRoutingModule } from '../components/cpanel/cpanel.routes';
import { assessmentRoutingModule } from '../components/assessment/assessment.routes';
import { PaymentRoutingModule } from '../components/payment/payment.routes';
import { usersRoutingModule } from '../components/users/users.routes';
import { licensesRoutingModule } from '../components/licenses/licenses.routes';
import { organizationsRoutingModule } from '../components/organizations/organizations.routes';
import { groupsRoutingModule } from '../components/groups/groups.routes';
import { membersRoutingModule } from '../components/members/members.routes';
import { soarIaRoutingModule } from '../components/soar-ia/soar-ia.routes';
import { messagesRoutingModule } from '../components/messages/messages.routes';
import { eventsRoutingModule } from '../components/events/events.routes';
import { settingsRoutingModule } from '../components/settings/settings.routes';
import { financialRoutingModule } from '../components/financial/financial.routes';
import { profileRoutingModule } from '../components/profile/profile.routes';
import { supportRoutingModule } from '../components/support/support.routes';
import { paragraphRoutingModule } from '../components/paragraph/paragraph.routes';
import { changelogRoutingModule } from '../components/changelog/changelog.routes';

export const content: Routes = [
  {
    path: '',
    children: [
      ...cpanelRoutingModule.routes,
      ...assessmentRoutingModule.routes,
      ...usersRoutingModule.routes,
      ...licensesRoutingModule.routes,
      ...organizationsRoutingModule.routes,
      ...groupsRoutingModule.routes,
      ...membersRoutingModule.routes,
      ...soarIaRoutingModule.routes,
      ...messagesRoutingModule.routes,
      ...eventsRoutingModule.routes,
      ...settingsRoutingModule.routes,
      ...financialRoutingModule.routes,
      ...profileRoutingModule.routes,
      ...supportRoutingModule.routes,
      ...PaymentRoutingModule.routes,
      ...paragraphRoutingModule.routes,
      ...changelogRoutingModule.routes
    ],
  },
];
@NgModule({
  imports: [RouterModule.forRoot(admin)],
  exports: [RouterModule],
})
export class SharedRoutingModule {
    static routes = admin;
}
